<template>
  <component :is="editAction ? 'wiskModal' : 'b-container'" fluid :visible="!!editAction" @hide="setGlobalAction({ type: 'adjustmentTypes', action: null })" size="lg" :title="translations.txtAdjustmentTypes" hideFooter>
    <wiskGrid :rowData="rowData" :columnDefs="columns" resetRows parentGridName="AdjustmentTypes" :gridStyle="{ height: height || '600px' }"
      :excel="{ fileName: 'AdjustmentTypes' }" :header="{ hideSearch: true }" v-bind="$attrs">
      <template v-slot:additional-header-controls>
        <wiskInput :label="translations.txtServingSizesShowArchived" v-model="showArchived" inputType="checkbox" />
        <b-button size="sm" @click="add" variant="primary">
          {{ translations.txtAdjustmentTypeNew }}
        </b-button>
      </template>
    </wiskGrid>
  </component>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AdjustmentTypeCapitalizeBadgeCellRenderer from '@/components/accounting/AdjustmentTypeCapitalizeBadgeCellRenderer'

export default {
  name: 'AdjustmentTypes',
  components: {},
  props: { editAction: Object, height: String },
  data() {
    return {
      showArchived: false
    }
  },
  computed: {
    ...mapState(['translations', 'currentPermissionsByType', 'adjustmentTypes']),
    kindLabels() {
      return {
        fee: this.translations.txtAdjustmentTypeKindFee,
        tax: this.translations.txtAdjustmentTypeKindTax,
        deposit: this.translations.txtAdjustmentTypeKindDeposit
      }
    },
    basisLabels() {
      return {
        flat: this.translations.txtAdjustmentTypeBasisFlat,
        per_unit: this.translations.txtAdjustmentTypeBasisPerUnit,
        per_case: this.translations.txtAdjustmentTypeBasisPerCase,
        percent_of_line: this.translations.txtAdjustmentTypeBasisPercentOfLine
      }
    },
    rowData() {
      if (this.showArchived) {
        return this.adjustmentTypes
      }
      return this.adjustmentTypes.filter(a => a && !a.archived)
    },
    columns() {
      return [
        {
          headerName: this.translations.txtAdjustmentTypeLabel,
          sortOrder: 1000,
          colId: 'label',
          field: 'label'
        },
        {
          headerName: this.translations.txtAdjustmentTypeKind,
          sortOrder: 2000,
          colId: 'kind',
          field: 'kind',
          valueFormatter: params => this.kindLabels[params.value] || params.value,
          cellRendererParams: { useValueFormatter: true }
        },
        {
          headerName: this.translations.txtAdjustmentTypeBasis,
          sortOrder: 3000,
          colId: 'basis',
          field: 'basis',
          valueFormatter: params => this.basisLabels[params.value] || params.value,
          cellRendererParams: { useValueFormatter: true }
        },
        {
          headerName: this.translations.txtAdjustmentTypeDefaultRate,
          sortOrder: 4000,
          colId: 'default_rate',
          field: 'default_rate'
        },
        {
          headerName: this.translations.txtAdjustmentTypeCapitalizeIntoCost,
          sortOrder: 4500,
          colId: 'capitalize_into_cost',
          field: 'capitalize_into_cost',
          cellRenderer: AdjustmentTypeCapitalizeBadgeCellRenderer
        },
        {
          colId: 'more',
          sortOrder: 5000,
          headerName: this.translations.columnDetails,
          minWidth: 100,
          width: 100,
          cellClass: ['cell-more-details'],
          cellRenderer: 'CellMoreDetails',
          suppressSortingToolPanel: true,
          suppressFiltersToolPanel: true,
          cellRendererParams: {
            excludeFromExport: true,
            onClick: id => {
              this.setGlobalAction({ type: 'adjustmentTypeEdit', action: { id } })
            }
          },
          valueGetter: params => ({
            id: (params.data && params.data.id) || 0,
            group: !!params.node.group
          })
        }
      ]
    }
  },
  methods: {
    ...mapActions(['setGlobalAction']),
    add() {
      this.setGlobalAction({ type: 'adjustmentTypeEdit', action: { id: 0 } })
    }
  },
  watch: {}
}
</script>

<style lang="scss"></style>
